import { css } from "@emotion/css";
import {
  addDays,
  addHours,
  addMonths,
  addWeeks,
  startOfDay,
  startOfMonth,
  startOfToday,
  startOfWeek,
} from "date-fns";
import React from "react";
import { Item, Menu, Separator, Submenu } from "react-contexify";
import { FiTrash } from "react-icons/fi";
import { Note } from "./state/data";
import {
  putInBacklog,
  putInDayBacklog,
  putInMonthBacklog,
  putInWeekBacklog,
  putToExactDateWithNoLayout,
} from "./state/data/utils";
import { useNotesOperations } from "./state/state/store";

export const NoteRightClickMenu = (props) => {
  const { updateNoteById, removeNote } = useNotesOperations();

  const onDelete = ({ event, props }) => {
    removeNote(props.noteId);
  };

  const onMove = ({ event, props, data, triggerEvent }) => {
    updateNoteById(props.noteId, data.effector());
  };

  return (
    <Menu
      id="note_right_click_menu"
      className={css`
        z-index: 400;
      `}
    >
      <Submenu label="Move to...">
        <Item
          data={{ effector: () => putInDayBacklog(startOfToday()) }}
          /* @ts-ignore */
          onClick={onMove}
        >
          Today
        </Item>
        {/* @ts-ignore */}
        <Item
          data={{
            effector: () => putToExactDateWithNoLayout(new Date()),
          }}
          /* @ts-ignore */
          onClick={onMove}
        >
          Right now
        </Item>
        <Item
          data={{
            effector: () => putToExactDateWithNoLayout(addHours(new Date(), 1)),
          }}
          /* @ts-ignore */
          onClick={onMove}
        >
          In an hour
        </Item>
        <Item
          data={{
            effector: () => putToExactDateWithNoLayout(addHours(new Date(), 2)),
          }}
          /* @ts-ignore */
          onClick={onMove}
        >
          In two hours
        </Item>
        <Item
          data={{
            effector: () => putInDayBacklog(startOfDay(addDays(new Date(), 1))),
          }}
          /* @ts-ignore */
          onClick={onMove}
        >
          Tomorrow
        </Item>
        <Item
          data={{
            effector: () =>
              putInWeekBacklog(
                addWeeks(startOfWeek(new Date(), { weekStartsOn: 1 }), 0)
              ),
          }}
          /* @ts-ignore */
          onClick={onMove}
        >
          This week
        </Item>
        <Item
          data={{
            effector: () =>
              putInWeekBacklog(
                addWeeks(
                  startOfWeek(addDays(new Date(), 2), { weekStartsOn: 1 }),
                  1
                )
              ),
          }}
          /* @ts-ignore */
          onClick={onMove}
        >
          Next week
        </Item>
        <Item
          data={{
            effector: () =>
              putInWeekBacklog(
                addWeeks(startOfWeek(new Date(), { weekStartsOn: 1 }), 2)
              ),
          }}
          /* @ts-ignore */
          onClick={onMove}
        >
          Week after next
        </Item>
        <Item
          data={{
            effector: () =>
              putInMonthBacklog(addMonths(startOfMonth(new Date()), 1)),
          }}
          /* @ts-ignore */
          onClick={onMove}
        >
          Next month
        </Item>
        {/* @ts-ignore */}
        <Item data={{ effector: () => putInBacklog }} onClick={onMove}>
          Unscheduled
        </Item>
        {/* TODO: Tomorrow at the same time */}
      </Submenu>
      <Separator />
      {/* @ts-ignore */}
      <Item onClick={onDelete}>
        <div
          className={css`
            font-weight: bold;
            display: flex;
            align-items: center;
            &:hover {
              color: white;
            }
          `}
        >
          <FiTrash
            className={css`
              margin-right: 10px;
              color: red;
            `}
          />
          <span className={css`font-weight: bold;}`}>Delete</span>
        </div>
      </Item>
      {/* <Separator />
      <Item onClick={() => alert("beep")}>Change background </Item> */}
    </Menu>
  );
};
